import { AfterViewInit, Component, Inject, Injector, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { AODADialog } from '@core/utilities/aoda-dialog';
import { BaseComponent } from '@shared/components/base.component';
import { DialogData } from '@shared/components/confirmation-dialog/DialogData';
import { ValidationFunctions } from '@shared/validators/validation-functions';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { FormConfigDirective } from '../../../shared/directives/form-config.directive';
import { AutofocusByContentDirective } from '../../../shared/directives/autofocus-by-content.directive';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-convert-worksheet',
  templateUrl: './convert-worksheet.component.html',
  styleUrls: ['./convert-worksheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    FormConfigDirective,
    MatInput,
    AutofocusByContentDirective,
    MatError,
    MatDialogActions,
    MatButton,
    AsyncPipe,
    TranslatePipe
  ]
})
export class ConvertWorksheetComponent extends BaseComponent implements OnInit, AfterViewInit {
  data: DialogData;
  calculatorNameForm: UntypedFormGroup;
  srcWorksheetName: string;

  constructor(
    private readonly injector: Injector,
    private readonly dialogRef: MatDialogRef<ConvertWorksheetComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: DialogData
  ) {
    super(injector);
    this.data = data;
    this.dialogRef.disableClose = true;
  }

  ngOnInit() {
    super.ngOnInit();
    this.srcWorksheetName = this.data.worksheet.name;
    this.data.worksheet.name = '';
    this.buildForm();
  }

  ngAfterViewInit() {
    AODADialog.applyAllFixes();
  }

  convert() {
    if (this.calculatorNameForm.invalid) {
      return false;
    }
    this.data.worksheet.name = this.calculatorName.value?.trim();
    this.dialogRef.close(this.data.worksheet);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  private buildForm() {
    this.calculatorNameForm = this.formBuilder.group({
      calculatorName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(30), ValidationFunctions.empty]]
    });
  }

  get calculatorName() {
    return this.calculatorNameForm.get('calculatorName');
  }
}
